module.exports = __webpack_public_path__ + "media/images/login-bg-0819530d1783b03d58d391b664489381.png";